import { Controller } from "@hotwired/stimulus"
import moment from 'moment'

export default class extends Controller {
  connect() {}

  updateLabel(event) {
    const fileName = $(event.target).val().split("\\").pop()
    $(event.target).siblings(".custom-file-label").addClass("selected").html(fileName)

  }
}
